module.exports = __webpack_public_path__ + "static/media/LogoLMU.d107e943.png";